import React from "react";
import { Helmet } from "react-helmet";
import {cartItem} from "../../models/cart.model";
import {getStructuredItem} from "../../helpers/scripts/seoScript";
import {capitalizeFirstLetter} from "../../helpers/helperMethods";

interface IItemScript {
    item: cartItem,
    scriptType: string,
    location_id: number,
    userId: number,
}

const ItemScript: React.FunctionComponent<IItemScript> = ({item, scriptType, location_id, userId}) =>
{
    const itemDetails = getStructuredItem(item, location_id)

    return (
        <>
            <Helmet>
                <title>
                    {`${capitalizeFirstLetter(item?.name)} ${item?.isKidsCombo || item?.isTry2Combo ? "": item?.category_name} | Café Zupas`}
                </title>
                <meta
                    name="description"
                    content={item?.description}
                />
                <script>
                    {
                      `    
                      window.dataLayer.push({
                        'event': ${JSON.stringify(scriptType)},
                        'user_id': ${userId || null},
                        'ecommerce': {
                            'currency': "USD",
                            'value': ${item?.price || item?.display_price || item?.base_price},
                            'items': [
                                ${JSON.stringify(itemDetails)}
                            ]
                        }
                    });
                     `
                    }
                </script>
            </Helmet>
        </>
    );
};

export default ItemScript;
